<div class="dialog">
  <h4 mat-dialog-title>{{ data.title }}</h4>
  <form [formGroup]="form" (keydown.enter)="$event.stopPropagation()">
    <mat-form-field>
      <mat-label>{{ 'common_field_label' | translate }}</mat-label>
      <input matInput formControlName="displayName" required />
      <mat-error *ngIf="!data.displayName" [innerHTML]="'common_error_label_required' | translate"></mat-error>
    </mat-form-field>
    <div mat-dialog-actions>
      <button type="button" mat-button (click)="onNoClick()">{{ 'common_btn_cancel' | translate }}</button>
      <button mat-button [mat-dialog-close]="form?.value" color="accent" [disabled]="!form.valid">{{ 'common_btn_save' | translate }}</button>
    </div>
  </form>
</div>
